import axios from 'axios';
//export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
export const API_BASE_URL = 'https://apibanco.bimescolar.org/api';

const api = axios.create({ 
  baseURL: API_BASE_URL,
});

const publicPaths = ['/auth/login', '/auth/register', '/auth/forgot-password', '/auth/reset-password'];

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    const isPublicPath = publicPaths.some(path => config.url.includes(path));

    if (token && !isPublicPath) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // LOG PARA DEBUG
    if (config.method === 'post' || config.method === 'put') {
      console.log('📤 Requisição:', {
        url: config.url,
        method: config.method,
        data: config.data
      });
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    console.log('✅ Resposta:', response.data);
    return response;
  },
  async (error) => {
    // LOG PARA DEBUG - Mostra erro detalhado
    const status = error.response?.status;
    const originalRequest = error.config || {};
    const isPublicPath = publicPaths.some(path => (originalRequest.url || '').includes(path));


    if (status === 400) {
      console.error('❌ Erro 400 - Dados Inválidos:', {
        url: error.config?.url,
        dadosEnviados: JSON.parse(error.config?.data || '{}'),
        erroBackend: error.response?.data
      });
    } else if (status === 404) {
      console.error('❌ Erro 404 - Não Encontrado:', {
        url: error.config?.url,
        erroBackend: error.response?.data
      });
    } else if (status === 409) {
      console.error('❌ Erro 409 - Conflito/Duplicado:', {
        url: error.config?.url,
        erroBackend: error.response?.data
      });
    } else if (status === 500) {
      console.error('❌ Erro 500 - Erro Interno do Servidor:', {
        url: error.config?.url,
        method: error.config?.method?.toUpperCase(),
        dadosEnviados: error.config?.data ? JSON.parse(error.config.data) : null,
        erroBackend: error.response?.data,
        mensagem: error.response?.data?.message,
        stack: error.response?.data?.stack
      });
    }

    // Check if the error is a 401, not a retry, and not a public path
    if (error.response?.status === 401 && !originalRequest._retry && !isPublicPath) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refreshToken');

      if (refreshToken) {
        try {
          const response = await axios.post(`${API_BASE_URL}/auth/refresh-token`, { refreshToken });
          const { accessToken } = response.data;

          localStorage.setItem('accessToken', accessToken);
          api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
          originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;

          return api(originalRequest);
        } catch (refreshError) {
          console.error("Refresh token failed. Redirecting to login.", refreshError);
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('user');
          localStorage.removeItem('isAuthenticated');

          if (window.location.pathname !== '/login') {
            window.location.href = '/login';
          }
          return Promise.reject(refreshError);
        }
      } else {
        console.error("No refresh token available. Redirecting to login.");
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        localStorage.removeItem('isAuthenticated');

        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export const getVideos = () => api.get('/video');
export const getVideoById = (id) => api.get(`/video/${id}`);
export const getVideoStreamUrl = (id) => {
  const token = localStorage.getItem('accessToken');
  return `${API_BASE_URL}/video/stream/${id}?token=${token}`;
};

export default api;